import type { CustomersPhoto } from 'src/components/organisms/CustomersPhotos/components/CustomersPhotos';
import type { ProductReview } from 'src/redux/reviews/types';

/** Alt text where the customer wrote no caption, which on live data is nearly every photo. */
const PHOTO_ALT_FALLBACK = 'Customer photo';

/** Newest first. ISO 8601 strings compare as dates. */
const byDateDescending = (a: ProductReview, b: ProductReview) => b.date.localeCompare(a.date);

/**
 * The photos across a page of reviews, newest review first. Sorted here because Feefo's
 * photo-filtered page came back in almost, but not quite, date order. Photos only: a Feefo
 * video's `url` is a player page rather than an image.
 */
export const adaptCustomersPhotosToUI = (reviews: ProductReview[]): CustomersPhoto[] =>
  [...reviews].sort(byDateDescending).flatMap((review) =>
    review.media
      .filter(({ type }) => type === 'photo')
      .map(({ caption, id, url }) => ({
        alt: caption || PHOTO_ALT_FALLBACK,
        id,
        reviewId: review.id,
        url,
      })),
  );
